export default function HeroBackground() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      <img
        src="/images/landing-v2/hero/top-ellipse.svg"
        alt=""
        className="absolute left-1/2 top-0 w-[140%] min-w-[1200px] max-w-none -translate-x-1/2"
      />
      <img
        src="/images/landing-v2/hero/bottom-ellipse.svg"
        alt=""
        className="absolute bottom-0 left-1/2 w-[140%] min-w-[1200px] max-w-none -translate-x-1/2"
      />
    </div>
  );
}
